class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
//     this.mainDetailsToggle = this.querySelector('.menu-child-wrapper-main');

    this.addEventListener('keyup', onKeyUpEscape);
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  
  onFocusOut() {
    document.querySelector('main').classList.remove('menu-overlay');
    document.querySelector('main').style.pointerEvents = 'initial';
        setTimeout(() => {
    console.log('focusout');
      if (!this.contains(document.activeElement)) this.close();
//     document.querySelector('main').classList.remove('menu-overlay');
//     document.querySelector('main').style.pointerEvents = 'initial';
    
    document.querySelectorAll('.parent-main-menu').forEach((value, index)=>{
      value.querySelector('.header__menu-item').style.color = "#000";
    });
  })
    
  }

  close() {
    console.log('close');
    this.mainDetailsToggle.removeAttribute('open');
  }
  
  
}

customElements.define('details-disclosure', DetailsDisclosure);
